__webpack_require__.p = "https://diagnostic-preprod.curebay.in/";